"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericForm = void 0;
const formik_1 = require("formik");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_redux_1 = require("react-router-redux");
const Button_1 = require("../../components/Button/Button");
const Card_1 = require("../../components/Card/Card");
const CardTitle_1 = require("../../components/CardTitle/CardTitle");
const Loading_1 = require("../../components/Loading/Loading");
exports.GenericForm = (props) => {
    const { initialValues, onSubmit, validationSchema, loadingSelector, tNamespace, EmbedForm, recordId, onSubmitOptions, onDelete, onBack = true, colClassName = 'col-lg-6', rowClassName = 'row justify-content-md-center', } = props;
    const dispatch = react_redux_1.useDispatch();
    const isLoading = react_redux_1.useSelector(loadingSelector);
    const { t } = react_i18next_1.useTranslation([tNamespace, 'GenericForm']);
    const onBackClick = react_1.useCallback(() => {
        if (onBack) {
            if (onBack === true)
                dispatch(react_router_redux_1.goBack());
            else if (typeof onBack === 'string')
                dispatch(react_router_redux_1.push(onBack));
            else if (typeof onBack === 'function')
                onBack();
        }
    }, [dispatch, onBack]);
    const onDeleteClick = react_1.useCallback(() => {
        if (recordId && onDelete)
            dispatch(onDelete(recordId));
    }, [dispatch, recordId]);
    const onFormikSubmit = react_1.useCallback((data) => {
        if (recordId)
            dispatch(onSubmit(recordId, data, onSubmitOptions));
        else
            dispatch(onSubmit(data, onSubmitOptions));
    }, [dispatch, onSubmitOptions, onSubmit, recordId]);
    if (isLoading)
        return react_1.default.createElement(Loading_1.Loading, { centeredVertical: true });
    return (react_1.default.createElement("div", { className: rowClassName },
        react_1.default.createElement("div", { className: colClassName },
            react_1.default.createElement(Card_1.Card, null,
                react_1.default.createElement(CardTitle_1.CardTitle, null, t('title')),
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(formik_1.Formik, { onSubmit: onFormikSubmit, initialValues: initialValues, validationSchema: validationSchema }, (formikProps) => (react_1.default.createElement("form", { onSubmit: formikProps.handleSubmit },
                        react_1.default.createElement(EmbedForm, { formikProps: formikProps }),
                        onBack ? (react_1.default.createElement(Button_1.Button, { id: "GenericForm-back", onClick: onBackClick }, t(['back', 'GenericForm:back']))) : (''),
                        react_1.default.createElement(Button_1.Button, { type: "submit", id: "GenericFormScene-submit", className: "float-right" }, t(['save', 'GenericForm:save']))))),
                    onDelete ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("hr", null),
                        react_1.default.createElement(Button_1.Button, { id: "delete-button", color: "danger", onClick: onDeleteClick }, t(['delete', 'GenericForm:delete'])))) : (''))))));
};
//# sourceMappingURL=GenericForm.js.map